import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmptyPagePage } from './empty-page.page';

const routes: Routes = [
  {
    path: '',
    component: EmptyPagePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmptyPagePageRoutingModule {}
